import { ApmIcons } from '@mitsubishi/ui/icons';

/** Id di `ea_system_usage_type`: 1 raffreddamento, 2 riscaldamento, 3 entrambi. */
const COOLING_USAGE_TYPE_IDS = ['1', '3'];
const HEATING_USAGE_TYPE_IDS = ['2', '3'];

/**
 * Icone del tipo di carico, le stesse che la card dell'analisi energetica mostra accanto al nome.
 * Il tipo "raffreddamento e riscaldamento" ne restituisce due.
 */
export function getLoadTypeIcons(systemUsageTypeId: string | undefined | null): ApmIcons[] {
  if (!systemUsageTypeId) {
    return [];
  }
  const icons: ApmIcons[] = [];
  if (COOLING_USAGE_TYPE_IDS.includes(systemUsageTypeId)) {
    icons.push('o_snowflake');
  }
  if (HEATING_USAGE_TYPE_IDS.includes(systemUsageTypeId)) {
    icons.push('o_flame');
  }
  return icons;
}
